import { ELIGIBILITY } from '@tmap/mmm-core/commonApp/funnelCategories'
import nestGet from '@tmap/mmm-core/nestGet';

const checkEligibility = (fieldConfigs, data) => {
  const eligibilityConfigs = fieldConfigs.filter(fc => fc.category === ELIGIBILITY && fc.type === "checkbox");
  return eligibilityConfigs.reduce((result, fc) => result && nestGet(data, fc.path.split('.')) == true, true);
}

export default checkEligibility;